import React, { Fragment } from 'react'
import { useMemo } from 'sb-hooks'
import { Field, useFieldState } from 'formular'

import { Row, Box } from 'components/_new/layout'
import { ChipList } from 'components/_new/controls'
import Text from 'components/_new/typography/Text/Text'


type GroupProps = {
  field: Field<Review.LikeTag[]>
  emoji: string
  title: ReactIntlMessage
  items: Review.LikeTag[]
}

const Group: React.FunctionComponent<GroupProps> = ({ field, emoji, title, items }) => {
  const { value } = useFieldState(field)

  const chipItems = useMemo(() => {
    const selectedIds = value.map((item) => item.id)

    return items.map((item) => ({
      key: item.id,
      label: item.name,
      checked: selectedIds.includes(item.id),
      onClick: (checked) => {
        if (checked) {
          field.set([ ...value, item ])
        }
        else {
          field.set(value.filter((filteredItem) => filteredItem.id !== item.id))
        }
      },
    }))
  }, [ field, items, value ])

  return (
    <Fragment>
      <Row justify="start">
        <Box mr={8}>
          <Text size="22-32" message={emoji} />
        </Box>
        <Text size="12-16" semibold uppercase letterSpacing message={title} />
      </Row>
      <Box mt={8}>
        <ChipList items={chipItems} />
      </Box>
    </Fragment>
  )
}

export default Group
